import useUserValidated from "../../customHooks/useUserValidated";
import { LivePhotoCardProps } from "../../models/IEnums.model";
import TakeLivePhotoCard from "../TakeLivePhotoCard";

const ImageUploadAndLivePhoto: React.FC<
  Pick<LivePhotoCardProps, "getFileUrl">
> = ({ getFileUrl }) => {
  const { isValid } = useUserValidated();

  if (isValid) return <></>;

  return (
    <div className="w-lg-50 w-100">
      <TakeLivePhotoCard
        label="Take a live photo"
        required
        getFileUrl={getFileUrl}
      />
    </div>
  );
};

export default ImageUploadAndLivePhoto;
